import React from 'react';

export default function CMSPagesTable({ records, onEdit, onDelete, onToggle }) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="bg-gray-50 text-left text-xs uppercase text-gray-500">
          <tr>
            <th className="p-4">Title</th>
            <th className="p-4">URL</th>
            <th className="p-4">Publication status</th>
            <th className="p-4 text-right">Actions</th>
          </tr>
        </thead>
        <tbody>
          {records.map((page) => {
            const published = page.status === 'published';
            return (
              <tr key={page.id} className="border-t">
                <td className="p-4 font-semibold text-gray-900">{page.title || page.page_name}</td>
                <td className="p-4 font-mono text-xs">{page.route || ('/content/' + page.slug)}</td>
                <td className="p-4">{published ? 'Published' : page.status || 'Draft'}</td>
                <td className="p-4">
                  <div className="flex justify-end gap-2">
                    <button type="button" onClick={() => onEdit(page)} className="px-3 py-1 rounded border border-indigo-300 text-indigo-700">Edit</button>
                    <button type="button" onClick={() => onDelete(page)} className="px-3 py-1 rounded border border-red-300 text-red-700">Delete</button>
                    <button type="button" onClick={() => onToggle(page, published ? 'unpublished' : 'published')} className="px-3 py-1 rounded border border-green-300 text-green-700">{published ? 'Unpublish' : 'Publish'}</button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
